// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xof6Kq {
  background: var(--surface-neutral-white, #ffffff);
  border-radius: var(--radius-s, 4px);
  box-shadow: var(--shadow-s, 0 2px 4px 0 rgba(0, 0, 0, 0.12));
  height: calc(100vh - 155px);
  min-height: 360px;
}

.H7LCBC {
  margin: 0;
  padding: var(--spacing-3) var(--spacing-3) var(--spacing-2) var(--spacing-3);
  border-bottom: 1px solid var(--border-neutral-soft, #e5e7eb);
  font-family: var(--font-family-base);
  font-size: var(--type-paragraph-lg-font-size, 16px);
  font-weight: var(--type-paragraph-lg-regular-font-weight, 600);
  line-height: var(--type-paragraph-lg-regular-line-height, 24px);
  color: var(--text-neutral-dark, #1a1a1a);
}

.eNk8LC {
  display: flex;
  flex-direction: column;
  padding: var(--spacing-3, 24px);
}

.uzKGjz {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5, 12px);
  margin-bottom: var(--spacing-1-5);
}

.EeHUTs {
  height: 1px;
  background: var(--border-neutral-soft, #e5e7eb);
  margin: var(--spacing-2, 16px) 0;
}

.NuYMNJ {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1, 8px);
}

.gTeKGC {
  display: flex;
  align-items: center;
  gap: var(--spacing-1, 8px);
}

.ABvCiu {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.gRcdBQ {
  width: 24px;
  height: 24px;
}

.Jm__ll {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  background: var(--surface-primary-medium, #d64000);
  color: var(--surface-neutral-white, #ffffff);
  font-size: var(--type-label-md-font-size, 14px);
  font-weight: 600;
}

.UxpC8q {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  border: 1px solid var(--border-neutral-soft, #e5e7eb);
  color: var(--text-neutral-medium, #6b7280);
  font-size: var(--type-label-md-font-size, 14px);
  font-weight: 600;
}

.AzwHbS {
  font-family: var(--font-family-base);
  font-size: var(--type-paragraph-lg-font-size, 16px);
  font-weight: 400;
  color: var(--text-neutral-dark, #1a1a1a);
}

.Z2zvnx {
  color: var(--text-neutral-medium, #6b7280);
}

.zyKCMw {
  margin-left: auto;
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.rJ8bEm {
  width: 16px;
  height: 16px;
}

.vZziu1 {
  padding-left: 0;
}

.T5_kE9 {
  font-family: var(--font-family-base);
  font-size: var(--type-paragraph-md-font-size, 14px);
  font-weight: 600;
  color: var(--text-neutral-dark, #1a1a1a);
}

.GofgD1 {
  padding-left: 0;
  display: flex;
  width: 100%;
}

.KzLPDN {
  font-family: var(--font-family-base);
  font-size: var(--type-paragraph-md-font-size, 14px);
  font-weight: 600;
  color: var(--text-neutral-dark, #1a1a1a);
  width: 50%;
  text-align: left;
}

.I6MWPy {
  font-family: var(--font-family-base);
  font-size: var(--type-paragraph-md-font-size, 14px);
  font-weight: 600;
  color: var(--text-neutral-dark, #1a1a1a);
  width: 50%;
  text-align: left;
}

.an_v8q {
  padding-left: 0;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5, 4px);
}

.YPufzT {
  font-family: var(--font-family-base);
  font-size: var(--type-paragraph-md-font-size, 14px);
  font-weight: 600;
  color: var(--text-neutral-dark, #1a1a1a);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/HiringPage/components/ContractSummarySidebar/ContractSummarySidebar.module.css"],"names":[],"mappings":"AAAA;EACE,iDAAiD;EACjD,mCAAmC;EACnC,4DAA4D;EAC5D,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,4EAA4E;EAC5E,4DAA4D;EAC5D,oCAAoC;EACpC,mDAAmD;EACnD,8DAA8D;EAC9D,+DAA+D;EAC/D,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,+CAA+C;EAC/C,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kDAAkD;EAClD,4CAA4C;EAC5C,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,0CAA0C;EAC1C,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,mDAAmD;EACnD,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,mDAAmD;EACnD,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,mDAAmD;EACnD,gBAAgB;EAChB,wCAAwC;EACxC,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,mDAAmD;EACnD,gBAAgB;EAChB,wCAAwC;EACxC,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,mDAAmD;EACnD,gBAAgB;EAChB,wCAAwC;AAC1C","sourcesContent":[".summaryCard {\n  background: var(--surface-neutral-white, #ffffff);\n  border-radius: var(--radius-s, 4px);\n  box-shadow: var(--shadow-s, 0 2px 4px 0 rgba(0, 0, 0, 0.12));\n  height: calc(100vh - 155px);\n  min-height: 360px;\n}\n\n.summaryTitle {\n  margin: 0;\n  padding: var(--spacing-3) var(--spacing-3) var(--spacing-2) var(--spacing-3);\n  border-bottom: 1px solid var(--border-neutral-soft, #e5e7eb);\n  font-family: var(--font-family-base);\n  font-size: var(--type-paragraph-lg-font-size, 16px);\n  font-weight: var(--type-paragraph-lg-regular-font-weight, 600);\n  line-height: var(--type-paragraph-lg-regular-line-height, 24px);\n  color: var(--text-neutral-dark, #1a1a1a);\n}\n\n.summarySteps {\n  display: flex;\n  flex-direction: column;\n  padding: var(--spacing-3, 24px);\n}\n\n.summarySection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5, 12px);\n  margin-bottom: var(--spacing-1-5);\n}\n\n.summaryDivider {\n  height: 1px;\n  background: var(--border-neutral-soft, #e5e7eb);\n  margin: var(--spacing-2, 16px) 0;\n}\n\n.summaryStep {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1, 8px);\n}\n\n.stepHeader {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1, 8px);\n}\n\n.stepIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n}\n\n.stepIconCompleted {\n  width: 24px;\n  height: 24px;\n}\n\n.stepIconActive {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 12px;\n  background: var(--surface-primary-medium, #d64000);\n  color: var(--surface-neutral-white, #ffffff);\n  font-size: var(--type-label-md-font-size, 14px);\n  font-weight: 600;\n}\n\n.stepIconInactive {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--border-neutral-soft, #e5e7eb);\n  color: var(--text-neutral-medium, #6b7280);\n  font-size: var(--type-label-md-font-size, 14px);\n  font-weight: 600;\n}\n\n.stepLabel {\n  font-family: var(--font-family-base);\n  font-size: var(--type-paragraph-lg-font-size, 16px);\n  font-weight: 400;\n  color: var(--text-neutral-dark, #1a1a1a);\n}\n\n.stepLabelInactive {\n  color: var(--text-neutral-medium, #6b7280);\n}\n\n.editButton {\n  margin-left: auto;\n  width: 24px;\n  height: 24px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.editIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.stepAddressBlock {\n  padding-left: 0;\n}\n\n.stepAddress {\n  font-family: var(--font-family-base);\n  font-size: var(--type-paragraph-md-font-size, 14px);\n  font-weight: 600;\n  color: var(--text-neutral-dark, #1a1a1a);\n}\n\n.stepEmployeeCountBlock {\n  padding-left: 0;\n  display: flex;\n  width: 100%;\n}\n\n.stepEmployeeCountLabel {\n  font-family: var(--font-family-base);\n  font-size: var(--type-paragraph-md-font-size, 14px);\n  font-weight: 600;\n  color: var(--text-neutral-dark, #1a1a1a);\n  width: 50%;\n  text-align: left;\n}\n\n.stepEmployeeCountValue {\n  font-family: var(--font-family-base);\n  font-size: var(--type-paragraph-md-font-size, 14px);\n  font-weight: 600;\n  color: var(--text-neutral-dark, #1a1a1a);\n  width: 50%;\n  text-align: left;\n}\n\n.stepProductFamiliesBlock {\n  padding-left: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5, 4px);\n}\n\n.stepProductFamily {\n  font-family: var(--font-family-base);\n  font-size: var(--type-paragraph-md-font-size, 14px);\n  font-weight: 600;\n  color: var(--text-neutral-dark, #1a1a1a);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"summaryCard": `xof6Kq`,
	"summaryTitle": `H7LCBC`,
	"summarySteps": `eNk8LC`,
	"summarySection": `uzKGjz`,
	"summaryDivider": `EeHUTs`,
	"summaryStep": `NuYMNJ`,
	"stepHeader": `gTeKGC`,
	"stepIcon": `ABvCiu`,
	"stepIconCompleted": `gRcdBQ`,
	"stepIconActive": `Jm__ll`,
	"stepIconInactive": `UxpC8q`,
	"stepLabel": `AzwHbS`,
	"stepLabelInactive": `Z2zvnx`,
	"editButton": `zyKCMw`,
	"editIcon": `rJ8bEm`,
	"stepAddressBlock": `vZziu1`,
	"stepAddress": `T5_kE9`,
	"stepEmployeeCountBlock": `GofgD1`,
	"stepEmployeeCountLabel": `KzLPDN`,
	"stepEmployeeCountValue": `I6MWPy`,
	"stepProductFamiliesBlock": `an_v8q`,
	"stepProductFamily": `YPufzT`
};
module.exports = ___CSS_LOADER_EXPORT___;
